window.appendUtmInputs = function(formId) {
    const params = new URLSearchParams(window.location.search);
    const form = document.getElementById(formId);

    const allowedUtmKeys = [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_term',
        'utm_content'
    ];

    for (const [key, value] of params.entries()) {
        if (!key || !value) continue;

        if (!allowedUtmKeys.includes(key)) continue;

        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value;

        form.appendChild(input);
    }
}